import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ComumModule } from './../../../shared/comum.module';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { TipoDealerCadastroComponent } from './tipo-dealer-cadastro/tipo-dealer-cadastro.component';
import { TipoDealerFiltroComponent } from './tipo-dealer-filtro/tipo-dealer-filtro.component';
import { TipoDealerListaComponent } from './tipo-dealer-lista/tipo-dealer-lista.component';
import { TipoDealerService } from './tipo-dealer-service/tipo.dealer.service';
import { TipoDealerComponent } from './tipo-dealer.component';

@NgModule({
  imports: [
    HttpModule,
    FormsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    TipoDealerComponent
  ],
  declarations: [
    TipoDealerComponent,
    TipoDealerListaComponent,
    TipoDealerCadastroComponent,
    TipoDealerFiltroComponent
  ],
  providers: [
    TipoDealerService
  ]
})
export class TipoDealerModule { }
